import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Configuration editor for the basic comment step type.
 * Allows admins to enter markdown content.
 * @param root0 - The component props
 * @param root0.value - Current configuration value
 * @param root0.onChange - Callback when configuration changes
 * @param root0.disabled - Whether the form is disabled
 * @param root0.errors - Validation errors to display
 * @returns The configuration editor component
 */
export function ConfigEditor({ value, onChange, disabled, errors, }) {
    return (_jsxs("div", { className: "space-y-2", children: [_jsx("label", { htmlFor: "comment-content", className: "text-sm font-medium", children: "Content" }), _jsx("textarea", { id: "comment-content", value: value.content, onChange: (e) => { onChange({ ...value, content: e.target.value }); }, disabled: disabled, placeholder: "Enter markdown content...", rows: 8, className: `
					w-full rounded-md border px-3 py-2 text-sm
					focus:outline-none focus:ring-2 focus:ring-ring
					disabled:cursor-not-allowed disabled:opacity-50
					${errors?.content ? "border-destructive" : "border-input"}
				` }), errors?.content && (_jsx("p", { className: "text-sm text-destructive", children: errors.content })), _jsx("p", { className: "text-xs text-muted-foreground", children: "Supports Markdown formatting (headings, lists, links, etc.)" })] }));
}
//# sourceMappingURL=ConfigEditor.js.map